export default {
  namespaced: true,
  assigned_video_tours: {
    title: "Tours em Vídeo Atribuídos",
    single: "tour em vídeo atribuído",
    all: "todos os tours em vídeo atribuídos",

    current_assignment: "atribuição atual",
    schedule_video_tours: "agendar tours em vídeo",
    change: "alterar",
    change_now: "alterar agora",

    video_tour: "tour em vídeo",
    video_tours: "tours em vídeo",
    sector: "setor",
    sectors: "setores",

    analyst: "analista",
    supervisor: "supervisor",
    change_supervisor: "alterar supervisor",
    change_video_tours: "alterar tours em vídeo",

    scheduled: "agendado",
    programmed: "agendado",
    manual_change: "alteração manual",

    init_date: "data de início",
    end_date: "data de término",
    active_at: "ativo em",
    active_at_help: "Filtrar atribuições ativas em uma data e hora específicas.",
    since: "desde",

    select_supervisor: "selecione um supervisor",
    select_sector: "selecione um tour em vídeo",
    select_sectors: "selecione tours em vídeo",
    select_analyst: "selecione um analista",

    supervisor_optional: "O supervisor é opcional.",
    no_supervisor: "nenhum supervisor atribuído",
    no_video_tours: "nenhum tour em vídeo atribuído",

    effective_assignment: "atribuição efetiva",
    assignment_history: "histórico de atribuições",
    programmed_assignment: "atribuição agendada",
    current_supervisor: "supervisor atual",
    current_video_tours: "tours em vídeo atuais",

    save_programmed: "salvar atribuição agendada",
    save_change: "salvar alteração",

    messages: {
      created: "Atribuição criada com sucesso.",
      updated: "Atribuição atualizada com sucesso.",
      deleted: "Atribuição removida com sucesso.",
      changed: "Atribuição alterada com sucesso.",
      closed: "A substituição atual foi encerrada com sucesso.",
      load_error: "Erro ao carregar atribuições.",
      save_error: "Erro ao salvar atribuição.",
      delete_error: "Erro ao remover atribuição.",
      change_error: "Erro ao alterar atribuição.",
      required_supervisor: "Por favor, selecione um supervisor.",
      required_video_tours: "Por favor, selecione pelo menos um tour em vídeo.",
    },
  },
};